import * as trace from 'owa-trace';
import { useGetEffectivePathToNavigate } from './useGetEffectivePathToNavigate';
import { useMemo } from 'react';
import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import { useNavigate as useReactRouterNavigate } from 'react-router-dom';

/**
 * Returns a method that can be used to navigate to new or previous routes while preserving whitelisted search params.
 * @returns navigate function
 */
export const useNavigate = (): NavigateFunction => {
    try {
        const reactRouterNavigate = useReactRouterNavigate();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const getEffectivePathToNavigate = useGetEffectivePathToNavigate();

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const navigate = useMemo(() => {
            function navigate(to: To, options?: NavigateOptions): void;
            function navigate(delta: number): void;
            function navigate(to: To | number, options?: NavigateOptions): void {
                if (typeof to === 'number') {
                    reactRouterNavigate(to);
                } else {
                    reactRouterNavigate(getEffectivePathToNavigate(to), options);
                }
            }

            return navigate;
        }, [reactRouterNavigate, getEffectivePathToNavigate]);

        return navigate;
    } catch (e) {
        trace.errorThatWillCauseAlert('useNavigateError: ' + e?.message);
        return () => {};
    }
};
